import { render, staticRenderFns } from "./CustomerDetail-LinkedAccounts.vue?vue&type=template&id=509e40c4"
import script from "./CustomerDetail-LinkedAccounts.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-LinkedAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports